import React from 'react'
import { addSeparators } from 'utils'
import { DiscountCode } from 'discounts/types'

interface UsageCountProps {
    usage?: DiscountCode['usage']
}

export const UsageCount: React.FC<UsageCountProps> = ({ usage }) => {
    if (!usage) {
        return <>Unlimited</>
    }

    return (
        <>
            {addSeparators(usage.used)}/{addSeparators(usage.total)}
        </>
    )
}
